import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useAvatarDefaultAdd() {
    const router = useAppRouter();

    const model = reactive({
        type: null,
        name: '',
        gender: 0,
        isPublished: false,
        imageFile: null
    });

    const validations = {
        name: { required },
        type: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            avatarService.default.create(model.type, model.name, model.gender, model.isPublished, model.imageFile),
        onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.DEFAULT.INDEX })
    });

    return { model, v$, create, typeList, genderList };
}

const genderList = [
    { label: 'Female', value: 0 },
    { label: 'Male', value: 1 }
];

const typeList = [
    { label: 'Bot', value: 1 },
    { label: 'Admin', value: 2 },
    { label: 'DefaultAvatar', value: 3 },
    { label: 'FakePlayer', value: 4 }
];
